import { useState, useEffect } from "react";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { Card, Box, Button, Paper, TextField, MenuItem } from "@mui/material";
import {
  searchStyle,
  boxStyle,
  buttonPosition,
  StyledTableCell,
  StyledTableRow,
  headerStyle,
} from "../style/style";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { getobj, postobj, dltobj, updateobj } from "../apicall/apicall";
import "react-notifications/lib/notifications.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import DistributorDetail from "./DistributorDetail";
import { validateField } from "../apicall/commonFunction";
import { dist } from "../apicall/constants";
export default function Distributorlist() {
  const [id, setid] = useState();
  const [refresh, setrefresh] = useState(false);
  const [distributors, setdistributors] = useState([]);
  const [loaded, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [totalpage, setpaget] = useState();
  const [open, setopen] = useState(false);
  const [distriburotname, setdistributorname] = useState();
  const [distributor, setdistributor] = useState({});
  const [addDistributor, setaddDistributor] = useState({
    first_name: "NA",
    last_name: "NA",
    phone: "NA",
    email: "NA",
    company_name: "NA",
    company_address: "NA",
    state: "NA",
    city: "NA",
    zip_code: "NA",
  });
  const [search, setsearch] = useState("");
  const [detail, setdetail] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedAction, setselectedAction] = useState("");

  function resetData() {
    setaddDistributor({
      first_name: "NA",
      last_name: "NA",
      phone: "NA",
      email: "NA",
      company_name: "NA",
      company_address: "NA",
      state: "NA",
      city: "NA",
      zip_code: "NA",
    });
    setErrors({});
  }
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setaddDistributor({
      ...addDistributor,
      [name]: value,
    });
  };
  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "distributor/distributor-list/?page=" +
      value;
    const d = getobj(url);
    d.then(function (res) {
      if (res && res.results && res.results.data) {
        setdistributors(res.results.data);
        setloaded(false);
      } else {
        console.error("Invalid response structure:", res);
        setdistributors([]);
        setloaded(false);
      }
    }).catch((err) => {
      console.error("Error fetching distributors:", err);
      setdistributors([]);
      setloaded(false);
    });
  };
  const handleSearch = (e, val) => {
    e.preventDefault();

    if (detail) {
      setrefresh(!refresh);
    } else {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "distributor/distributor-list/?search=" +
        val;
      let result = getobj(url);
      result
        .then(function (res) {
          if (res && res.results && res.results.data) {
            setdistributors(res.results.data);
            console.log(res.results.data, "dis");
            setloaded(false);
            if (res.count % 5 > 0) {
              setpaget(Math.floor(res.count / 5) + 1);
            } else {
              setpaget(Math.floor(res.count / 5));
            }
          } else {
            console.error("Invalid response structure:", res);
            setdistributors([]);
            setloaded(false);
          }
        })
        .catch((err) => {
          console.error("Error during search:", err);
          setdistributors([]);
          setloaded(false);
        });
    }
  };

  const addProfile = async (id) => {
    //console.log("TEDT", id);
    const data = addDistributor;
    data["id"] = id;

    let url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
    const d = postobj(url, data);
    d.then(function (res) {
      // console.log(res.id);
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.success("Distributor added Successfully");
      setopen(false);
      resetData();
      setrefresh(!refresh);
    });
  };

  function validated(data) {
    const not_null = Object.keys(data).map((i) => {
      console.log(i, data[i]);

      if (data[i] === "NA" || data[i] === "") {
        return false;
      }
      return true;
    });
    const email = data["email"].includes("@");
    const phone = data["phone"].length <= 10;

    console.log(not_null, email, phone);
    return (
      not_null[0] &&
      not_null[1] &&
      not_null[2] &&
      not_null[3] &&
      email &&
      phone &&
      not_null[4]
    );
  }

  const validateForm = () => {
    const newErrors = {};
    if (!addDistributor.first_name.trim()) {
      newErrors.first_name = "First Name cannot be blank";
    }

    if (!addDistributor.last_name.trim()) {
      newErrors.last_name = "Last Name cannot be blank";
    }

    if (!/^\d{1,10}$/.test(addDistributor.phone)) {
      newErrors.phone = "Please enter a 10-digit phone number";
    }

    if (!addDistributor.company_name.trim()) {
      newErrors.company_name = "Company Name cannot be blank";
    }

    if (!addDistributor.company_address.trim()) {
      newErrors.company_address = "Company Address cannot be blank";
    }

    if (!addDistributor.state.trim()) {
      newErrors.state = "State cannot be blank";
    }

    if (!addDistributor.city.trim()) {
      newErrors.city = "City cannot be blank";
    }

    if (!/^\d{1,5}$/.test(addDistributor.zip_code)) {
      newErrors.zip_code = "Please enter a 5-digit zip code";
    }

    let val = validateField(addDistributor, dist);
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErrors[field] = val[field];
      });
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let url =
      process.env.REACT_APP_ZEWA_URL + "user/add-customer/?role=DISTRIBUTOR";
    const val = validateForm();
    const validate = validated(addDistributor) && val;
    console.log(validate, "validate");
    if (validate) {
      setErrors({});
      const res = postobj(url, addDistributor);

      res
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then((response) => {
          // Do something with the response

          console.log(res);
          addProfile(response.id);
          // setopen(false);
          //NotificationManager.success("Successfully Added.", "Added", 2000);
        })
        .catch((error) => {
          console.log(error);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Email already registered", "Failed", 2000);
        });
    }
  };

  const handleAction = (id, val, user) => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "distributor/distributor-list/";

    if (val === "Delete") {
      const res = dltobj(url, { id: user.customer_id["id"] });
      res
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then((r) => {
          if (r.status === 200) {
            NotificationManager.success(
              "Successfully deleted.",
              "Deleted",
              2000,
            );
            setpage(1);
            setrefresh(!refresh);
          }
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err);
        });
    } else if (val === "Detail") {
      setsearch("");
      setdistributor(user);
      setid(user.customer_id["id"]);
      setdistributorname(user.company_name);
      setdetail(true);
    } else {
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: user.customer_id["id"], active: status };
      const res = updateobj(url, data);
      res
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then((res) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Status Updated.", "Updated", 2000);

          setrefresh(!refresh);
        })
        .catch((err) => {
          NotificationManager.error("Something went wrong");
        });
      //console.log(data);
    }
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "distributor/distributor-list/?page=" +
      page;
    const d = getobj(url);
    d.then(function (res) {
      console.log(res, "r");
      if (res && res.results && res.results.status === 200) {
        setdistributors(res.results.data);
        setloaded(false);
        console.log("hello");
        console.log(res.results, "dis");
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }
      } else {
        console.log(res, "dis");
        setdistributors([]);
        setloaded(false);
      }
    }).catch((err) => {
      console.error("Error fetching distributor list:", err);
      setdistributors([]);
      setloaded(false);
    });
  }, [refresh, detail, page]);

  return (
    <div>
      {" "}
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>
          {detail ? distriburotname : "Distributor"}
          <form style={searchStyle} onSubmit={(e) => handleSearch(e, search)}>
            <FormControl variant="standard" sx={searchStyle}>
              <InputLabel htmlFor="input-with-icon-adornment">
                Search ...
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchSharpIcon color="primary" />
                  </InputAdornment>
                }
                value={search}
                onChange={(e) => {
                  console.log(e.target.value, "V");
                  if (e.target.value === "") {
                    setsearch("");
                    handleSearch(e, "");
                  } else {
                    //setsearch("");
                    setsearch(e.target.value);
                  }
                }}
              />
            </FormControl>
          </form>
        </Card>
      </Card>
      {detail ? (
        <DistributorDetail
          detail={detail}
          setdetail={setdetail}
          id={id}
          distributor={distributor}
          setdistributor={setdistributor}
          search={{ search: search, setsearch: setsearch }}
          refresh={refresh}
          setrefresh={setrefresh}
          distriburotname={{
            distriburotname: distriburotname,
            setdistributorname: setdistributorname,
          }}
        />
      ) : (
        <div>
          <Box sx={boxStyle}>
            <Box sx={buttonPosition}>
              <Button
                sx={{ margin: "5px" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  setopen(true);
                }}
              >
                add distributor
              </Button>
            </Box>
          </Box>
          {loaded ? (
            <img
              src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
              alt="loading..."
            />
          ) : (
            <Box sx={boxStyle}>
              {distributors.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>
                          <b>Company Name</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Name</b>
                        </StyledTableCell>

                        <StyledTableCell>
                          <b>Email</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Phone</b>
                        </StyledTableCell>

                        <StyledTableCell>
                          <b>Status</b>
                        </StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {distributors.length > 0 &&
                        distributors.map((user) => (
                          <StyledTableRow key={user.id}>
                            <StyledTableCell>
                              {user.company_name}
                            </StyledTableCell>
                            <StyledTableCell>
                              {user.customer_id["first_name"] !== ""
                                ? user.customer_id["first_name"] +
                                  " " +
                                  user.customer_id["last_name"]
                                : user.customer_id["email"].split("@")[0]}
                            </StyledTableCell>

                            <StyledTableCell>
                              {user.customer_id["email"]}
                            </StyledTableCell>
                            <StyledTableCell>
                              {user.phone !== "0"
                                ? user.customer_id["phone_number"]
                                : "NA"}
                            </StyledTableCell>
                            <StyledTableCell>
                              {user.customer_id["active"]
                                ? "Active"
                                : "Inactive"}
                            </StyledTableCell>

                            <StyledTableCell>
                              <Button>
                                <TextField
                                  select
                                  name="user_list"
                                  id="deviceName"
                                  sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                  variant="outlined"
                                  label="Action"
                                  value={selectedAction}
                                  onChange={(e) => {
                                    handleAction(user.id, e.target.value, user);
                                    setselectedAction("");
                                  }}
                                >
                                  <MenuItem value="Detail">Detail</MenuItem>
                                  <MenuItem
                                    value={
                                      user.customer_id["active"]
                                        ? "Deactivate"
                                        : "Activate"
                                    }
                                  >
                                    {user.customer_id["active"]
                                      ? "Deactivate"
                                      : "Activate"}
                                  </MenuItem>
                                  <MenuItem value="Delete">Delete</MenuItem>
                                </TextField>
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                    <Pagination
                      count={totalpage}
                      page={page}
                      variant="outlined"
                      color="primary"
                      onChange={handlePagechange}
                    />
                  </Table>
                </TableContainer>
              ) : (
                <Card>
                  <p>No Distributor Added yet</p>
                </Card>
              )}
            </Box>
          )}
          <NotificationContainer />
          <Dialog
            open={open}
            onClose={() => {
              resetData();
              setopen(false);
            }}
          >
            <DialogTitle>Add Distributor</DialogTitle>
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter First Name"
                  name="first_name"
                  type="text"
                  onChange={handleChange}
                  required
                  helperText={errors.first_name ? errors.first_name : ""}
                  error={errors.first_name || false}
                />

                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter last Name"
                  name="last_name"
                  type="text"
                  onChange={handleChange}
                  required
                  helperText={errors.last_name ? errors.last_name : ""}
                  error={errors.last_name || false}
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter Email"
                  name="email"
                  type="email"
                  onChange={handleChange}
                  required
                  error={errors.email || false}
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter Phone Number"
                  name="phone"
                  type="text"
                  onChange={handleChange}
                  helperText={errors.phone ? errors.phone : ""}
                  error={errors.phone || false}
                  required
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter Company Name"
                  name="company_name"
                  type="text"
                  onChange={handleChange}
                  helperText={errors.company_name ? errors.company_name : ""}
                  error={errors.company_name || false}
                  required
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter Company Address"
                  name="company_address"
                  type="text"
                  onChange={handleChange}
                  helperText={
                    errors.company_address ? errors.company_address : ""
                  }
                  error={errors.company_address || false}
                  required
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter City Name"
                  name="city"
                  type="text"
                  onChange={handleChange}
                  helperText={errors.city ? errors.city : ""}
                  error={errors.city || false}
                  required
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter State Name"
                  name="state"
                  type="text"
                  onChange={handleChange}
                  helperText={errors.state ? errors.state : ""}
                  error={errors.state || false}
                  required
                />
                <TextField
                  id="outlined-basic"
                  sx={{ margin: "5px" }}
                  variant="outlined"
                  label="Enter Zip Code"
                  name="zip_code"
                  type="text"
                  onChange={handleChange}
                  helperText={errors.zip_code ? errors.zip_code : ""}
                  error={errors.zip_code || false}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  // onClick={() => {
                  //   //console.log(addAdmin);
                  //   handleSubmit(addDistributor);
                  // }}
                >
                  add
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    resetData();
                    setopen(false);
                  }}
                >
                  cancel
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
}
